require('./currencyDropdownOptionComponent.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @ constants
const { CURRENCIES_SYMBOLS } = require('constants/currencies');

class CurrencyDropdownOptionComponent extends React.Component {

    constructor() {
        super();

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    handleMouseDown (event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.props.option.value) {
            this.props.onSelect(this.props.option, event);   
        }
    }

    handleMouseMove (event) {
        if (this.props.isFocused || !this.props.option.value) return;
        this.props.onFocus(this.props.option, event);
    }

    render() {
        const { className, option } = this.props;
        let isComponentTitle = false;
        let id;
        let content;

        if (option) {
            if (!!option.value) {
                id = `${option.value}_Options_${option.value}`;
                content = (
                    <div className="currency-dropdown-option-component__value">
                        <span className="currency-dropdown-option-component__currency-text" title={option.label}>{option.label}</span> 
                        <span className="currency-dropdown-option-component__currency-symbols">{option.value} ({CURRENCIES_SYMBOLS[option.value]})</span>
                    </div>
                );
            } else {
                isComponentTitle = true;
                content = (
                    <i className="currency-dropdown-option-component__title-text">{option.label}</i>
                );
            }
        }
        const classnamesOptionComponent = classNames(className, {
            'currency-dropdown-option-component': true,
            'currency-dropdown-option-component--title': isComponentTitle
        });
        return (
            <div
                id={id}
                className={classnamesOptionComponent}
                onMouseDown={this.handleMouseDown}
                onMouseMove={this.handleMouseMove}
            >{content}</div>
        );
    }
}

CurrencyDropdownOptionComponent.propTypes = {
    option: PropTypes.object.isRequired,
    className: PropTypes.string,
    onSelect: PropTypes.func,
    onFocus: PropTypes.func,
    isFocused: PropTypes.bool
};

module.exports = CurrencyDropdownOptionComponent;